import type { WorkflowSerializationError } from './features/workflowJsonSelectors';

/** Errors displayed at labware nodes or labware properties panel that match the labwareId */
export const LABWARE_ITEM_ALLOWLIST: readonly WorkflowSerializationError['message'][] =
  [
    'LABWARE_START_LOCATION_SELF_COLLISION',
    'LABWARE_START_LOCATION_SLOT_COLLISION',
    'LABWARE_START_LOCATION_SLOT_CAPACITY_EXCEEDED',
    'LABWARE_START_LOCATION_SLOT_INVALID',
  ] as const;
